import { useEffect, useState } from 'react';
import logo from '@/assets/logo.png';

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 1500);
    const completeTimer = setTimeout(() => onComplete(), 2000);
    
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(completeTimer);
    };
  }, [onComplete]);

  return (
    <div 
      className={`fixed inset-0 z-[100] flex items-center justify-center bg-background transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <div className="flex flex-col items-center gap-6 animate-pulse">
        <img 
          src={logo} 
          alt="SENTINEL" 
          className="w-24 h-24 brightness-0 dark:brightness-100 dark:invert animate-float"
        />
        <div className="text-3xl font-bold tracking-tight text-foreground">SENTINEL</div>
        <div className="w-32 h-1 bg-gradient-primary rounded-full overflow-hidden">
          <div className="h-full bg-primary/50 animate-shimmer" />
        </div>
      </div>
    </div>
  );
};
